// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_legalPageContainer__OnTW\\+ {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  min-height: calc(100vh - 100px);
  padding: 40px 20px;
}
.styles_legalPageContainer__OnTW\\+.styles_showHeader__i\\+YjE {
  min-height: calc(100vh - 200px);
}

.styles_boxContent__C7LMd {
  width: 100%;
  max-width: 1240px;
  background-color: var(--color-white);
  border-radius: 16px;
  padding: 32px 0 32px 16px;
  line-height: 1.6;
  border: 1px solid var(--strokes-blue, #DEE8F4);
}
@media (min-width: 768px) {
  .styles_boxContent__C7LMd {
    padding: 40px 0 40px 40px;
  }
}

.styles_legalContent__vKwOK {
  max-height: calc(100vh - 308px);
  overflow-y: auto;
}
@media (min-width: 768px) {
  .styles_legalContent__vKwOK {
    max-height: calc(100vh - 368px);
  }
}
@media (min-width: 1024px) {
  .styles_legalContent__vKwOK {
    max-height: calc(100vh - 388px);
  }
}

.styles_legalTitle__fnodK {
  font: var(--typography-h1);
  color: var(--color-black);
  margin: 0 0 16px 0;
  font-size: 28px;
}
@media (min-width: 768px) {
  .styles_legalTitle__fnodK {
    font-size: 34px;
  }
}

.styles_legalEffectiveDate__0uM4d {
  font: var(--typography-body-m-regular);
  color: var(--color-text-secondary);
  margin: 0 0 16px 0;
}

.styles_legalIntro__TR6BK {
  font: var(--typography-body-m-regular);
  color: var(--color-black);
  margin: 0 0 12px 0;
}

.styles_legalSection__siMJI {
  margin: 0 0 12px 0;
}
.styles_legalSection__siMJI h2 {
  font: var(--typography-h2);
  color: var(--color-black);
  margin: 0 0 8px 0;
}
.styles_legalSection__siMJI p {
  font: var(--typography-body-m-regular);
  color: var(--color-black);
  margin: 0 0 8px 0;
}
.styles_legalSection__siMJI ul {
  margin: 4px 0;
  padding-left: 20px;
}
.styles_legalSection__siMJI li {
  font: var(--typography-body-m-regular);
  color: var(--color-black);
  line-height: 1.6;
}
.styles_legalSection__siMJI a {
  color: var(--color-accent-blue);
  text-decoration: none;
}
.styles_legalSection__siMJI a:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/screens/info/styles.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,+BAAA;EACA,kBAAA;AAAF;AAEE;EACE,+BAAA;AAAJ;;AAIA;EACE,WAAA;EACA,iBAAA;EACA,oCAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,8CAAA;AADF;ACfE;EDSF;IAUI,yBAAA;EAAF;AACF;;AAGA;EACE,+BAAA;EACA,gBAAA;AAAF;ACzBE;EDuBF;IAKI,+BAAA;EACF;AACF;ACxBE;EDiBF;IASI,+BAAA;EAEF;AACF;;AACA;EACE,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAEF;AC1CE;EDoCF;IAOI,eAAA;EAGF;AACF;;AAAA;EACE,sCAAA;EACA,kCAAA;EACA,kBAAA;AAGF;;AAAA;EACE,sCAAA;EACA,yBAAA;EACA,kBAAA;AAGF;;AAAA;EACE,kBAAA;AAGF;AADE;EACE,0BAAA;EACA,yBAAA;EACA,iBAAA;AAGJ;AAAE;EACE,sCAAA;EACA,yBAAA;EACA,iBAAA;AAEJ;AACE;EACE,aAAA;EACA,kBAAA;AACJ;AAEE;EACE,sCAAA;EACA,yBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,+BAAA;EACA,qBAAA;AADJ;AAGI;EACE,0BAAA;AADN","sourcesContent":["@import \"mixins\";\n.legalPageContainer {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  gap: 40px;\n  min-height: calc(100vh - 100px);\n  padding: 40px 20px;\n\n  &.showHeader {\n    min-height: calc(100vh - 200px);\n  }\n}\n\n.boxContent {\n  width: 100%;\n  max-width: 1240px;\n  background-color: var(--color-white);\n  border-radius: 16px;\n  padding: 32px 0 32px 16px;\n  line-height: 1.6;\n  border: 1px solid var(--strokes-blue, #DEE8F4);\n\n  @include md {\n    padding: 40px 0 40px 40px;\n  }\n}\n\n.legalContent {\n  max-height: calc(100vh - 308px);\n  overflow-y: auto;\n\n  @include md {\n    max-height: calc(100vh - 368px);\n  }\n\n  @include lg {\n    max-height: calc(100vh - 388px);\n  }\n}\n\n.legalTitle {\n  font: var(--typography-h1);\n  color: var(--color-black);\n  margin: 0 0 16px 0;\n  font-size: 28px;\n\n  @include md {\n    font-size: 34px;\n  }\n}\n\n.legalEffectiveDate {\n  font: var(--typography-body-m-regular);\n  color: var(--color-text-secondary);\n  margin: 0 0 16px 0;\n}\n\n.legalIntro {\n  font: var(--typography-body-m-regular);\n  color: var(--color-black);\n  margin: 0 0 12px 0;\n}\n\n.legalSection {\n  margin: 0 0 12px 0;\n\n  h2 {\n    font: var(--typography-h2);\n    color: var(--color-black);\n    margin: 0 0 8px 0;\n  }\n\n  p {\n    font: var(--typography-body-m-regular);\n    color: var(--color-black);\n    margin: 0 0 8px 0;\n  }\n\n  ul {\n    margin: 4px 0;\n    padding-left: 20px;\n  }\n\n  li {\n    font: var(--typography-body-m-regular);\n    color: var(--color-black);\n    line-height: 1.6;\n  }\n\n  a {\n    color: var(--color-accent-blue);\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}","@mixin sm {\n  @media (min-width: 640px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (min-width: 1280px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"legalPageContainer": `styles_legalPageContainer__OnTW+`,
	"showHeader": `styles_showHeader__i+YjE`,
	"boxContent": `styles_boxContent__C7LMd`,
	"legalContent": `styles_legalContent__vKwOK`,
	"legalTitle": `styles_legalTitle__fnodK`,
	"legalEffectiveDate": `styles_legalEffectiveDate__0uM4d`,
	"legalIntro": `styles_legalIntro__TR6BK`,
	"legalSection": `styles_legalSection__siMJI`
};
export default ___CSS_LOADER_EXPORT___;
